import React from "react"
import { Link } from "react-router-dom"
import config from '../../config.json'

const ProjectTile = (props) => {
    return (
        <Link to={"/project/" + props.project.id} className="tile tile-project">
            <div className="tile-project-content">
                <div className="tile-image-container">
                    <img className="tile-image" src={config.s3_url + '/' + props.project.path + '/small/' + props.project.file_name} alt={props.project.file_name} />
                </div>
                <div className="tile-project-description">
                    <div className="pill pill-small">{props.categoryTitle}</div>
                    <div className="metadata" style={{margin: 0}}>
                        <div className="metadata-item">{new Date(props.project.created).toISOString().split('T')[0]}</div>
                    </div>
                    <h3>{props.project.title}</h3>
                    <p style={{margin: 0}}>{props.project.short_desc}</p>
                </div>
            </div>
            
        </Link>
    )
}

export default ProjectTile